import { useState, useEffect } from 'react';
import { fetchNew, fetchMenu } from '../../api/newsService';

const useFetchNews = (menuName) => {
  const [postNew, setPostNew] = useState([]);
  const [menuId, setMenuId] = useState(null);

  const getMenu = async () => {
    let res = await fetchMenu();
    if (res && res.data && res.data.data) {
      const menuItem = res.data.data.find(item => 
        item.name && item.name.toLowerCase().includes(menuName.toLowerCase())
      );
      if (menuItem) {
        setMenuId(menuItem.id);
      }
    }
  };

  const getData = async (categoryId) => {
    if (!categoryId) return; 
    try {
      let res = await fetchNew("",categoryId,1,20);
      if (res && res.data && res.data.data.lstNews) {
        setPostNew(res.data.data.lstNews);
      }
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu tin tức:", error);
    }
  };

  useEffect(() => {
    getMenu();
  }, []);

  useEffect(() => {
    if (menuId) {
      getData(menuId);
    }
  }, [menuId]);

  return postNew;
};

export default useFetchNews;
